import { hasRestrictedRole } from 'globalutils/fmUtils';
import { hasEnabledFeature } from 'globalutils/fmUtils';
import { Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForward';
import DonutGraphInfo from '../../DonutGraphInfo';
import { graphContainer } from './graphContainer';
import { titleToolTip } from './titleToolTip';
import { EventCategories } from '../../constants';
import { Trans, useTranslation } from 'react-i18next';
import React, { lazy } from 'react';

const layout = window?.$environment?.CURRENT_LAYOUT;
const ToolTip = lazy(() => import(`../../ToolTip`));
const RangeInfo = lazy(() => import(`../../RangeInfo`));
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));

const ACCIDENT_START_SECTION = 'newScoreCard.accidentTooltipTitle';
const SPEEDING_START_SECTION = 'newScoreCard.speedingTooltipTitle';
const DISTRACTED_START_SECTION = 'newScoreCard.distractedTooltipTitle';

const MoreInfoButton = ({ handleClick, translation: t }) => {
  const shouldShow = !hasRestrictedRole(['UNDER_WRITER']) && hasEnabledFeature('cameraIntegrationEnabled');

  if (!shouldShow) return null;

  return (
    <Grid style={{ display: 'flex' }} justify="flex-end">
      <Button
        variant="text"
        size="small"
        onClick={handleClick}
        style={{ background: 'transparent' }}
        endIcon={<ArrowForwardIosIcon />}
      >
        {t('scorecard.moreInfo')}
      </Button>
    </Grid>
  );
};

const BetaBadge = () => (
  <ToolTip title="Under Construction" arrow placement="right">
    <div className="cardBox">
      <div className="beta-banner">BETA</div>
    </div>
  </ToolTip>
);

export const DriverBehaviour = ({ Styled, scoreDes, handleClick, scoreCard }) => {
  const { t } = useTranslation();
  const { accidentEvents, speedingEvents, distractedEvents } = EventCategories;

  return (
    <div className="grid-item">
      <div className="flex-space-between">
        <div className="flex-row">
          <SubHeader
            variant="h1"
            className="statsHeading title"
            text={titleToolTip(
              t('scorecard.driverBehavior'),
              <p>
                <Trans i18nKey="scorecard.driverBehaviorDesc" />
              </p>,
              '',
              false,
              true
            )}
          />
          <BetaBadge />
        </div>
        <MoreInfoButton translation={t} handleClick={handleClick} />
      </div>

      <div className="subCharts">
        <div className="part1">
          <div className="fleet-score-graph">
            <div className="div60">
              <DonutGraphInfo
                centerTextData={{
                  count: scoreCard?.totalDrivingBehaviorScore,
                  text: scoreDes?.actualScore,
                }}
                onClick={() => {}}
                hideHover
                data={scoreCard?.totalDrivingBehaviorData}
                backgroundColor={['#eaeaea', '#908e8e', '#0097e6']}
              />
            </div>
            <Styled.DIV40 isBottomAlign>
              <RangeInfo isDriver smallGraph />
            </Styled.DIV40>
          </div>
        </div>

        <div className="part2">
          <div className="row2">
            <div className="col1">
              {graphContainer(
                scoreDes?.distractedDriving,
                scoreCard?.distractedDriving,
                true,
                '',
                false,
                `${t(DISTRACTED_START_SECTION)} ${distractedEvents?.join(', ')}`,
                scoreDes
              )}
            </div>
          </div>

          <div className="row1">
            <div className="col1">
              {graphContainer(
                t('scorecard.accident'),
                scoreCard?.accident,
                true,
                '',
                true,
                `${t(ACCIDENT_START_SECTION)} ${accidentEvents?.join(', ')}`,
                scoreDes
              )}
            </div>
            <div className="col2">
              {graphContainer(
                t('scorecard.speeding'),
                scoreCard?.speeding,
                true,
                '',
                false,
                `${t(SPEEDING_START_SECTION)} ${speedingEvents?.join(', ')}`,
                scoreDes
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
